<template>
  <SoAlert v-if="hasMeterpointTariff" type="warning">
    <p>The current agreements are:</p>
    <ul class="mt-2">
      <li
        v-for="(meterpointTariff, index) in meterpointTariffs"
        :key="index"
        data-testid="cot-tariff-meterpoint"
      >
        {{ meterpointTariff.currentTariff?.display }}
      </li>
    </ul>
    <p class="mt-2">
      You can
      <SoLink text="generate a quote" @click="openTariffQuoter()" />
      to get a monthly payment amount for the new customer.
    </p>
    <p class="mt-2">The estimated annual consumption for this property is:</p>
    <ul class="mt-2">
      <li v-for="(consumption, index) in consumptions" :key="index">
        {{ consumption.total }} kWh for {{ consumption.type }}
      </li>
    </ul>
  </SoAlert>
  <SoAlert v-else type="error">
    <p>There are no active agreements</p>
  </SoAlert>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoLink from "@/components/SoLink.vue"
  import { RouteNames } from "@/types/router"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { MeterpointTariffs } from "@/types/MeterpointTariffs"
  import { IMeter } from "@/models/meter/meter.types"
  import { IMeterpoint } from "@/models/meterpoint/meterpoint.types"

  export default defineComponent({
    components: {
      SoAlert,
      SoLink,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
    computed: {
      meterpointTariffs(): MeterpointTariffs {
        return this.current.meterpointTariffs.data
      },
      hasMeterpointTariff() {
        return Object.keys(this.meterpointTariffs).filter((key) => {
          return this.meterpointTariffs[key].currentTariff?.display
        }).length
      },
      consumptions() {
        return (
          Object.keys(this.meterpointTariffs)?.map((id) => {
            const total = this.getMeterpointTotal(
              this.meterpointTariffs[id].meterpoint,
            )
            const type = this.meterpointTariffs[id].meterpoint.isElectricity
              ? "electricity"
              : "gas"

            return {
              type,
              total,
            }
          }) ?? []
        )
      },
    },
    methods: {
      getMeterpointTotal(meterpoint: IMeterpoint) {
        return meterpoint.meters.reduce((metersTotal, meter) => {
          return metersTotal + this.getRegisterTotal(meter)
        }, 0)
      },
      getRegisterTotal(meter: IMeter) {
        return meter.registers.reduce((registerAcc, register) => {
          return registerAcc + register.usage
        }, 0)
      },
      openTariffQuoter() {
        const route = this.$router.resolve({ name: RouteNames.TariffQuoter })
        window.open(route.href, "_blank")
      },
    },
  })
</script>
